const moduleName = 'chainageChart';

export default moduleName;


// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/module.js